module.exports = __webpack_public_path__ + "static/img/plan-emergencia.19ef4e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguros-arl/Especialidades/plan-emergencia.png
// module id = 8CTz
// module chunks = 0